import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { queryParams } from '../commonFunctions';

export const useLenderId = () => {
  const location = useLocation();
  const [lenderId, setLenderId] = useState(queryParams()?.lenderId);

  useEffect(() => {
    setLenderId(queryParams()?.lenderId);
  }, [location.search]);

  return lenderId;
};
